module.exports = __webpack_public_path__ + "images/landingPageCake_1.png";